import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-brown-700 py-10 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto text-center" data-id="element-50">
        <ShieldCheckIcon className="w-8 h-8 text-gold-400 mx-auto mb-4" data-id="element-51" />

        <h3 className="font-heading text-lg text-cream-100 mb-4" data-id="element-52">
          Política de Privacidad
        </h3>

        <div className="text-sm text-cream-400 space-y-3 text-left max-w-2xl mx-auto" data-id="element-53">
          <p data-id="element-54">
            Tu privacidad es importante para nosotras. Al adquirir esta guía,
            tus datos personales (nombre y correo electrónico) serán utilizados
            únicamente para procesar tu compra y enviarte el PDF descargable.
          </p>
          <p data-id="element-55">
            No compartimos, vendemos ni cedemos tu información personal a
            terceros bajo ninguna circunstancia. Tus datos se almacenan de forma
            segura y se utilizan exclusivamente para la entrega del producto y
            comunicaciones relacionadas con tu compra.
          </p>
          <p data-id="element-56">
            Podés solicitar la eliminación de tus datos en cualquier momento
            escribiéndonos por correo electrónico. Al realizar tu compra,
            aceptás estos términos.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-brown-600" data-id="element-57">
          <p className="text-cream-500 text-xs" data-id="element-58">
            © {new Date().getFullYear()} · Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>;
}